<header class="main" [hidden]="!isVisible">
  <p-menubar [model]="menuItems">
    <ng-template #start> 
      <div style="width: 10rem;">
        HR.GE 
      </div>
      </ng-template>
    <ng-template #end>
      <div class="user-container">
        <div>
          <span>{{ currentUser?.userName }}</span>
          &nbsp;
        </div>
        <div class="user-actions">
          <a (click)="signOut()" style="cursor: pointer">
            <span class="fa fa-sign-out"> </span>
          </a>
        </div>
      </div>
    </ng-template>
  </p-menubar>
</header>
